;(() => {
  function initSampleForm(form) {
    const minQuantity = parseInt(form.dataset.colorsQuantity)

    const fieldName = minQuantity === 1 ? "color_id" : "color_ids"
    const colorButtons = form.querySelectorAll(`[name*="${fieldName}"]`)

    const submitButton = form.querySelector('button[type="submit"]')

    const toggleButton = () => {
      const selectedButtonsLength = form.querySelectorAll(
        `[name*="${fieldName}"]:checked`,
      ).length
      submitButton.disabled = selectedButtonsLength < minQuantity
    }

    for (const button of colorButtons) {
      button.addEventListener("change", toggleButton)
    }

    toggleButton()
  }

  window.addEventListener("load", () => {
    for (const form of document.querySelectorAll(".js--sample-form")) {
      initSampleForm(form)
    }
  })
})()
